import { Application, FeathersService, Query, Service } from "@feathersjs/feathers";
import { makeObservable, reaction, runInAction, computed, remove } from "mobx";
import client from "../feathers";
import { RootStore, BaseDataStore } from ".";
import { Item, Comment } from "../models";
import { DataType, IComment, ICommentReaction, IItem, ItemType, Services } from "../types";
import toast from 'react-hot-toast';

export class CommentStore extends BaseDataStore<Comment, IComment> {
  protected readonly reaction_service: FeathersService<Application<ICommentReaction>, Service<ICommentReaction>> = client.service(Services.Reaction);

  constructor(readonly rootStore: RootStore) {
    super(rootStore, Comment.create, DataType.Comment);
    makeObservable(this, {
      getActiveItem: computed,
    });

    this.reaction_service.on("removed", (data: ICommentReaction) => runInAction(() => this.container[data.comment_id].updateReaction(data, false)) );
    this.reaction_service.on("created", (data: ICommentReaction) => runInAction(() => this.container[data.comment_id].updateReaction(data, true)) );

    this.eventCallBacks.before.created.push(this.filterComments);

    this.eventCallBacks.after.created.push(this.notify);
    this.eventCallBacks.after.created.push(this.updateReplies(true));
    this.eventCallBacks.after.removed.push(this.updateReplies(false));
    this.eventCallBacks.error.created.push(() => {});
  }

  /*******************************************************************************************************************************************
   * Overwrites
   ********************************************************************************************************************************************/
  init() {
    super.init();
    // Load initial comments for questions
    reaction(() => this.rootStore.getActiveItem, () => {
      if (!this.rootStore.getActiveItem || !this.rootStore.getActiveItem.id) this.container = {};
      else this.loadItems(this.getCurFilter());
    }, {name: "comment_onActive_load"});
  }
  protected getCurFilter = (): Query => ({
    'comment.item_id': this.rootStore.getActiveItem.id
  });

  /*******************************************************************************************************************************************
   * Getter 
   ********************************************************************************************************************************************/
  get getSortedComments(): Comment[] {
    return Object.values(this.container).filter( c => !c.reply_id).sort( (a, b) => b.id - a.id)
  }
  get getActiveItem(): Item<IItem> {
    return this.rootStore.getActiveItem;
  }
  
  /*******************************************************************************************************************************************
   * Setter 
   ********************************************************************************************************************************************/

  /*******************************************************************************************************************************************
   * Actions
   ********************************************************************************************************************************************/

  /**
   * Creating a "toast" and says that user X comment on item #Y
   */
  notify = (data: IComment) => {
    if(Number(data.user_id) === this.rootStore.authStore.getCurUserID) return;

    const user = this.rootStore.userStore.getItemByID(data.user_id);
    const item = this.rootStore.questionStore.getItemByID(data.item_id);

    toast.success(`${user.displayName} commented on #${item.number}`, {icon: '📝'});
  }

  // updateCount = (add: boolean) => (data: IComment) => {
  //   runInAction(() => {
  //     this.rootStore.itemStores[data.type as ItemType].container[data.item_id]?.updateCommentCount(add);
  //     if(Number(data.item_id) === this.getActiveItem?.id) 
  //       this.getActiveItem.updateCommentCount(add);
  //   });
    
  // }
  updateReplies = (add: boolean) => (data: IComment) => {
    runInAction(() => {
      const replyId = Number(data.reply_id || 0);
      if(!replyId || !this.container[replyId]) return;
      if(add) this.container[replyId].replies.push(Number(data.id));
      else this.container[replyId].replies = this.container[replyId].replies.filter(c => c !== Number(data.id));
    });
    
  }

  filterComments = (data: IComment) => {
    if(Number(data.item_id) !== this.getActiveItem?.id) throw new Error("");
  }
}

